/* ============
 * Mutations for the sunstudy module
 * ============
 *
 * The mutations that are available on the
 * sunstudy module.
 */

import Sunstudy from '@/models/Sunstudy';

/* eslint-disable no-param-reassign */
export default {
  add(state, data) {
    state.seasons.push(new Sunstudy(data));
    state.position = 0;
    state.seasonPosition = 0;
  },
  setSunstudyMode(state, value) {
    state.showing = value;
  },
  setActivationButtonSunstudy(state, value) {
    state.showActivationButton = value;
  },
  setPosition(state, position) {
    state.position = position;
  },
  setAutoplay(state, autoplayTimeout) {
    state.autoplayTimeout = autoplayTimeout;
  },
  setSeason(state, season) {
    state.seasonPosition = season;
  },
};
